import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createCampaign = ({ churchId, campaignData }) => {
  return axios.post(`/churches/${churchId}/campaigns`, campaignData);
};

export const useCreateCampaign = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("campaigns-paginated");

      setNotification({
        type: "success",
        message: "Campaign created successfully!"
      });
    },
    ...config,
    mutationFn: createCampaign
  });
};
